import * as React from 'react';
import { injectIntl, InjectedIntlProps, FormattedMessage } from 'react-intl';
import { RouteComponentProps } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { PropagateLoader } from 'react-spinners';
import { readMessage, IMessage, getMessageThread } from '../../services/messages';
import moment from 'moment';
import SendMessageModal from '../shared/SendMessageModal';
import { getAccountDetails, getLoginDetails, IAccountDetails, ILogin } from '../../services/account';

// The query params passed in by react-router
interface IParams {
    id: string;
}

export default injectIntl((props: InjectedIntlProps & RouteComponentProps<IParams>) => {
    const [isLoading, setIsLoading] = useState(false);
    const [failedState, setFailedState] = useState(false);
    const [message, setMessage] = useState<IMessage | null>(null);
    const [thread, setThread] = useState<IMessage[] | null>(null);
    const [loginDetails, setLoginDetails] = useState<ILogin | null>(null);
    const [accountDetails, setAccountDetails] = useState<IAccountDetails | null>(null);

    const updateMessage = async () => {
        await setIsLoading(true);
        const req = await readMessage(props.match.params.id);
        const t = await getMessageThread(props.match.params.id);
        if (t && Array.isArray(t.messages)) {
            t.messages.map((m) => readMessage(m.name));
            setThread(t.messages);
        }
        const ret = await getAccountDetails();
        if (ret.accountDetails) {
            setAccountDetails(ret.accountDetails);
        }
        const login = await getLoginDetails();
        if (login.loginDetails) {
            setLoginDetails(login.loginDetails);
        }
        await setIsLoading(false);
        if (!req.success || !req.message) setFailedState(true);
        else {
            setFailedState(false);
            setMessage(req.message);
        }
    };

    const handleSend = () => {
        props.history.goBack()
    }

    useEffect(() => {
        updateMessage();
    }, []);

    if (message === null) return <div />;

    if (isLoading) {
        return (
            <div
                className="tab-pane wrapleft  wrapright-sec  mar-top-35 mobo-padding"
                id="Messages"
                role="tabpanel"
                aria-labelledby="profile-tab">
                <div className="container-fluid">
                    <div className="row">
                        <div className="p-5 d-flex justify-content-center">
                            <PropagateLoader size={15} loading color="#29447b" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (failedState) {
        return (
            <div
                className="tab-pane wrapleft  wrapright-sec  mar-top-35 mobo-padding"
                id="Messages"
                role="tabpanel"
                aria-labelledby="profile-tab">
                <div className="container-fluid">
                    <div className="row">
                        <h1>
                            <FormattedMessage
                                id="dash.msgs.read.error"
                                defaultMessage="There was an error loading this message"
                            />
                        </h1>
                    </div>
                </div>
            </div>
        );
    }

    const PARENS_CONTENT_REGEX = /\((.*?)\)/;
    const AT_ADDRESS = /^\s*([^ ]+)/;

    const renderMessage = (m: IMessage) => {
        const dateSent = moment(m.sent);
        const name = m.from.match(/\((.*?)\)/);
        const from = Array.isArray(name) && name.length > 0 ? name[1] : m.from;
        return (
            <div className="row mt-2" key={m.sent || m.read || m.subject}>
                <div className="col">
                    <div
                        className={`card`}>
                        <div className="card-header">
                            <FormattedMessage
                                id="dash.msgs.read.title"
                                defaultMessage={`Message from {email}`}
                                values={{
                                    email: from,
                                }}
                            />
                        </div>
                        <div className="card-body">
                            <h5 className="card-title">{m.subject}</h5>
                            <h6 className="card-subtitle mb-2 text-muted">{dateSent.fromNow()}</h6>
                            <p className="card-text">{m.body}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    const latestMessage = Array.isArray(thread) && thread.length ? thread[0] : null

    const replyToDatabase = latestMessage?.replyTo && !latestMessage?.replyTo.includes("@") && PARENS_CONTENT_REGEX.test(latestMessage?.replyTo)

    let fromLabel = latestMessage ? latestMessage.from : undefined
    const fromAddress = loginDetails?.userName
    let toAddress = latestMessage ? latestMessage.from : undefined
    
    fromLabel = (fromLabel?.match(PARENS_CONTENT_REGEX) || [,''])[1]
    toAddress = (toAddress?.match(AT_ADDRESS) || [,''])[1]

    if (replyToDatabase) {
        fromLabel += "/All Partners";
        toAddress = (latestMessage && latestMessage.replyTo) ? (latestMessage.replyTo.match(/^[^ ]+/)?.[0] ?? '') : ''
    } 
    
    return (
        <div
            className="tab-pane wrapleft  wrapright-sec  mar-top-35 mobo-padding"
            id="Messages"
            role="tabpanel"
            aria-labelledby="profile-tab">
            <br />
            <div className="container-fluid">
                {latestMessage && <SendMessageModal
                    from={fromAddress}
                    label={fromLabel}
                    to={toAddress}
                    replyTo={latestMessage.replyTo}
                    subject={`${`${latestMessage.subject}`.indexOf('RE:') !== -1 ? '' : 'RE: '}${latestMessage.subject}`}
                    onSave={handleSend}
                    raw
                />}
                {/* {latestMessage && latestMessage.name === props.match.params.id && (
                    <button
                        type="button"
                        className="primary"
                        data-toggle="modal"
                        data-target="#newMessageModal">
                        <FormattedMessage
                            id="dash.msgs.read.reply"
                            defaultMessage="Reply"
                        />
                    </button>
                )} */}
                {Array.isArray(thread) && thread.map(renderMessage)}
            </div>
        </div>
    );
});



// WEBPACK FOOTER //
// ./src/client/dashboard/ReadMessage.tsx